"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortObjectByFnOnValues = exports.sortObjectValues = exports.sortObjectKeys = exports.sortByName = exports.sortById = exports.noSort = exports.sortByDateTimestamp = exports.sortByTimestamp = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
/** normal timestamp Ms number */
const sortByTimestamp = (sn1, sn2, sort = iotv_v3_types_1.SortOrder.ASCENDING) => {
    return sort * (sn1.timestamp - sn2.timestamp);
};
exports.sortByTimestamp = sortByTimestamp;
// Parquet Schema objects will have data timestamps
const sortByDateTimestamp = (sn1, sn2, sort = iotv_v3_types_1.SortOrder.ASCENDING) => {
    return sort * ((sn1.timestamp < sn2.timestamp) ? -1 : 1);
};
exports.sortByDateTimestamp = sortByDateTimestamp;
// dummy sort for use in predicates
const noSort = (x, y) => -1;
exports.noSort = noSort;
const sortById = (sn1, sn2, sort = iotv_v3_types_1.SortOrder.ASCENDING) => {
    return sort * (sn1.id < sn2.id ? -1 : 1);
};
exports.sortById = sortById;
const sortByName = (sn1, sn2, sort = iotv_v3_types_1.SortOrder.ASCENDING) => {
    return sort * ((sn1.name ?? '') < (sn2.name ?? '') ? -1 : 1);
};
exports.sortByName = sortByName;
/** returns a clone with alpha sorted keys */
const sortObjectKeys = (object) => {
    return Object.fromEntries(Object.entries(object).sort(([k1, v1], [k2, v2]) => k1 < k2 ? -1 : 1));
};
exports.sortObjectKeys = sortObjectKeys;
/** returns a clone with alpha sorted values - likely not to work as imagined if not simple object */
const sortObjectValues = (object) => {
    return Object.fromEntries(Object.entries(object).sort(([k1, v1], [k2, v2]) => v1 < v2 ? -1 : 1));
};
exports.sortObjectValues = sortObjectValues;
/** returns a clone with alpha sorted values based on a provided fn to apply to values */
const sortObjectByFnOnValues = (object, fn) => {
    return Object.fromEntries(Object.entries(object).sort(([k1, v1], [k2, v2]) => fn(v1, v2)));
};
exports.sortObjectByFnOnValues = sortObjectByFnOnValues;
